import { Flow } from 'signup-constants/Flow';
import { FormType } from 'signup-ui-lego-core/constants/FormType';
import { isFlow } from '../../utils/isFlow';
import { getUtk } from 'usage-tracker-core/common/defaultTrackers';
import { getAcademyPageName } from '../../store/app/selectors';
const FORM_TITLE = {
  [FormType.SignupCompleted]: 'HubSpot Signup Form',
  [FormType.SignupInterest]: 'HubSpot Signup Interest Form'
};
export const getSubmitContext = (formType = FormType.SignupCompleted, state) => {
  const utk = getUtk();
  const academyContentName = getAcademyPageName(state);
  return Object.assign({
    pageUri: 'http://app.hubspot.com/signup-hubspot/',
    pageName: FORM_TITLE[formType]
  }, utk ? {
    hutk: utk
  } : {}, {}, isFlow(Flow.Academy) && academyContentName ? {
    pageName: academyContentName
  } : {});
};